document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('mak-video-popup-modal');
  var iframe = document.getElementById('mak-video-popup-iframe');
  if (!modal || !iframe) return;

  function getYouTubeId(url) {
    var match = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
    return match ? match[1] : null;
  }

  function openModal(videoUrl) {
    var id = getYouTubeId(videoUrl);
    if (!id) return;
    iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    modal.removeAttribute('hidden');
    document.body.classList.add('mak-video-popup-open');
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    iframe.src = ''; // stops playback
    document.body.classList.remove('mak-video-popup-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mak-popup-video]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.getAttribute('data-mak-popup-video'));
      return;
    }
    if (e.target.closest('[data-mak-popup-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
      closeModal();
    }
  });
});